import React, { useEffect, useState } from 'react'
import { Button, Table, Spinner, Row, Col, Badge } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getSubConcepts, activateSubConcept } from '../services/Concepts';

function SubConcepts() {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const handleEdit = (id) => navigate(`/editSubConcept/${id}`);
    const addSubConceptRedirect = () => navigate(`/addsubconcept`);

    const fetchData = async () => {
        try {
            setIsLoading(true);
            const items = await getSubConcepts();
            setData(items);
        } catch (error) {
            console.error(error);
            toast.error('Error al cargar subconceptos');
        } finally {
            setIsLoading(false);
        }
    };

    const handleInactive = async (id) => {
        try {
            await activateSubConcept(id, false);
            toast.success('Subconcepto inactivado');
            fetchData();
        } catch {
            toast.error('No se pudo inactivar');
        }
    };

    const handleActive = async (id) => {
        try {
            await activateSubConcept(id, true);
            toast.success('Subconcepto activado');
            fetchData();
        } catch {
            toast.error('No se pudo activar');
        }
    };

    useEffect(() => { fetchData(); }, []);

    return (
        <div>
            <h2>Subconceptos</h2>
            {isLoading ? (
                <Spinner animation="border" role="status" />
            ) : (
                <>
                    <Row>
                        <Col className='text-left'>
                            <Button className='m-3' variant="success" type="button" onClick={addSubConceptRedirect}>
                                Agregar subconcepto +
                            </Button>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <Table striped bordered hover responsive>
                                <thead>
                                    <tr>
                                        <th className='text-center'>#</th>
                                        <th className='text-center'>Editar</th>
                                        <th className='text-center'>Acción</th>
                                        <th className='text-center'>Nombre</th>
                                        <th className='text-center'>Concepto</th>
                                        <th className='text-center'>Estatus</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((s, idx) => (
                                        <tr key={s.id}>
                                            <td className='text-center'>{idx + 1}</td>
                                            <td className='text-center'>
                                                <Button size="sm" variant="warning" onClick={() => handleEdit(s.id)}>Editar</Button>
                                            </td>
                                            <td className='text-center'>
                                                {s.isActive ? (
                                                    <Button size="sm" variant="danger" onClick={() => handleInactive(s.id)}>Inactivar</Button>
                                                ) : (
                                                    <Button size="sm" variant="success" onClick={() => handleActive(s.id)}>Activar</Button>
                                                )}
                                            </td>
                                            <td>{s.name}</td>
                                            <td>{s.conceptName}</td>
                                            <td className='text-center'>
                                                {s.isActive ? <Badge bg="success">Activo</Badge> : <Badge bg="secondary">Inactivo</Badge>}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </>
            )}
            <ToastContainer />
        </div>
    );
}

export default SubConcepts;